module.exports = __webpack_public_path__ + "img/project_e5.5c66ff47.png";